import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router'; 
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../auth.service'; 
import { MenuService } from '../menu.service';

interface LoginResponse {
  access_token: string;
  refresh_token: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginForm!: FormGroup;
  isSubmitted = false;

  constructor(
    private formBuilder: FormBuilder, 
    private http: HttpClient, 
    private router: Router,
    private authService: AuthService,
    private menuService: MenuService) {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  get formControls() {
    return this.loginForm.controls;
  }

  submitLoginForm() {
    this.isSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }
  
    const data = {
      email: this.loginForm.value.email,
      password: this.loginForm.value.password
    };
  
    this.http.post<LoginResponse>('/api/login.php', data).pipe(
      switchMap((response) => {
        this.authService.setSessionTokens(response.access_token, response.refresh_token);

        return forkJoin([
          this.authService.loadCurrentUser(true),
          this.menuService.fetchMenuData()
        ]);
      })
    ).subscribe(
      ([currentUser]) => {
        const lastUrl = this.authService.lastUrl;
        this.authService.lastUrl = null;
        if (lastUrl && lastUrl !== '/login') {
          this.router.navigateByUrl(lastUrl);
        } else {
          this.router.navigateByUrl(this.authService.getDefaultRoute(currentUser));
        }
      },
      error => {
        // Handle error response
        console.error('Login error:', error);
      }
    );
  }
}
